import { QueryTuple, useLazyQuery } from '@apollo/client';
import { GET_WELDS_BY_ID } from '@bechtel/client-gql';
import { CommodityWrapper, PagingInput, Weld } from '@bechtel/types';

export function useWeldDetailById(fetchFromNetwork?: boolean): QueryTuple<
  { commoditiesByIds: CommodityWrapper },
  {
    input: [Weld['id']];
    paging: PagingInput;
  }
> {
  const response = useLazyQuery<
    { commoditiesByIds: CommodityWrapper },
    {
      input: [Weld['id']];
      paging: PagingInput;
    }
  >(
    GET_WELDS_BY_ID,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
          errorPolicy: 'all',
        }
      : {
          notifyOnNetworkStatusChange: true,
          errorPolicy: 'all',
        }
  );
  return response;
}
